import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { useStores } from '../../../cls/stores/MobXProvider'
import { runInAction } from 'mobx'
import { useSmartTranslation } from '../../../cls/TranslationContext'

/*
 * Component that logs out the user and redirects to the login page.
 * @param {Object} rootStore - The root store.
 * @returns {null} Null.
 */
/**
 * Logout
 *
 * React component that performs user logout on mount and redirects to the login page.
 * Uses MobX for state manipulation and `useNavigate` from React Router for redirection.
 *
 * @component
 * @returns {string} Translation string for "logging out" status text.
 */
const Logout = observer(() => {
	const { t } = useSmartTranslation()
	const { users } = useStores()
	const { loggedInUserId } = users

	const navigate = useNavigate()

	useEffect(() => {
		runInAction(() => {
			users.logout()
		})
		navigate('/login') // Redirect to login page after logout
	}, [loggedInUserId]) // Only depend on loggedInUserId

	return t('__please-wait%single.login.out')
})

export default Logout
